module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SiteSection', {
    attrs: {
      "sectionId": "section-talking",
      "sectionNo": "3",
      "label": "歷屆實習生分享",
      "title": "SPROUTERS' TALKING"
    }
  }, [_c('div', {
    staticClass: "label-container"
  }, [_c('GenerationLabel', {
    attrs: {
      "labelName": "2024",
      "isActive": _vm.isActive(2024)
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeGeneration(2024)
      }
    }
  }), _vm._v(" "), _c('GenerationLabel', {
    attrs: {
      "labelName": "2023",
      "isActive": _vm.isActive(2023)
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeGeneration(2023)
      }
    }
  }), _vm._v(" "), _c('GenerationLabel', {
    attrs: {
      "labelName": "2022",
      "isActive": _vm.isActive(2022)
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeGeneration(2022)
      }
    }
  }), _vm._v(" "), _c('GenerationLabel', {
    attrs: {
      "labelName": "2021",
      "isActive": _vm.isActive(2021)
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeGeneration(2021)
      }
    }
  }), _vm._v(" "), _c('GenerationLabel', {
    attrs: {
      "labelName": "2020",
      "isActive": _vm.isActive(2020)
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeGeneration(2020)
      }
    }
  }), _vm._v(" "), _c('GenerationLabel', {
    attrs: {
      "labelName": "2019",
      "isActive": _vm.isActive(2019)
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeGeneration(2019)
      }
    }
  }), _vm._v(" "), _c('GenerationLabel', {
    attrs: {
      "labelName": "2018",
      "isActive": _vm.isActive(2018)
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeGeneration(2018)
      }
    }
  }), _vm._v(" "), _c('GenerationLabel', {
    attrs: {
      "labelName": "2017",
      "isActive": _vm.isActive(2017)
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeGeneration(2017)
      }
    }
  }), _vm._v(" "), _c('GenerationLabel', {
    attrs: {
      "labelName": "2016",
      "isActive": _vm.isActive(2016)
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeGeneration(2016)
      }
    }
  }), _vm._v(" "), _c('GenerationLabel', {
    attrs: {
      "labelName": "2015",
      "isActive": _vm.isActive(2015)
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeGeneration(2015)
      }
    }
  }), _vm._v(" "), _c('GenerationLabel', {
    attrs: {
      "labelName": "2014",
      "isActive": _vm.isActive(2014)
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeGeneration(2014)
      }
    }
  })], 1), _vm._v(" "), (_vm.activeGeneration === 2024) ? _c('Generation', {
    attrs: {
      "sprouters": _vm.sprouters.sprouters2024,
      "activeGeneration": _vm.activeGeneration
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeGeneration == 2023) ? _c('Generation', {
    attrs: {
      "sprouters": _vm.sprouters.sprouters2023,
      "activeGeneration": _vm.activeGeneration
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeGeneration == 2022) ? _c('Generation', {
    attrs: {
      "sprouters": _vm.sprouters.sprouters2022,
      "activeGeneration": _vm.activeGeneration
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeGeneration == 2021) ? _c('Generation', {
    attrs: {
      "sprouters": _vm.sprouters.sprouters2021,
      "activeGeneration": _vm.activeGeneration
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeGeneration == 2020) ? _c('Generation', {
    attrs: {
      "sprouters": _vm.sprouters.sprouters2020,
      "activeGeneration": _vm.activeGeneration
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeGeneration == 2019) ? _c('Generation', {
    attrs: {
      "sprouters": _vm.sprouters.sprouters2019,
      "activeGeneration": _vm.activeGeneration
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeGeneration == 2018) ? _c('Generation', {
    attrs: {
      "sprouters": _vm.sprouters.sprouters2018,
      "activeGeneration": _vm.activeGeneration
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeGeneration == 2017) ? _c('Generation', {
    attrs: {
      "sprouters": _vm.sprouters.sprouters2017,
      "activeGeneration": _vm.activeGeneration
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeGeneration == 2016) ? _c('Generation', {
    attrs: {
      "sprouters": _vm.sprouters.sprouters2016,
      "activeGeneration": _vm.activeGeneration
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeGeneration == 2015) ? _c('Generation', {
    attrs: {
      "sprouters": _vm.sprouters.sprouters2015,
      "activeGeneration": _vm.activeGeneration
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeGeneration == 2014) ? _c('Generation', {
    attrs: {
      "sprouters": _vm.sprouters.sprouters2014,
      "activeGeneration": _vm.activeGeneration
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-eeba0304"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionTalking.vue
// module id = 689
// module chunks = 0